import { render, staticRenderFns } from "./seat.vue?vue&type=template&id=4d944ede"
import script from "./seat.vue?vue&type=script&lang=js"
export * from "./seat.vue?vue&type=script&lang=js"
import style0 from "./seat.vue?vue&type=style&index=0&id=4d944ede&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports